// extracted by mini-css-extract-plugin
export var menuIcon = "_tx-0";
export var menuIconInline = "_tx-1";